module.exports = __webpack_public_path__ + "img/gigash.44ab5300.jpg";